import React from "react";
import ConversationLayout from "./ConversationLayout";
import { Divider } from "antd";

const Agent = () => {
  return (
    <div className="flex flex-col h-full">
      <Divider orientation="left">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🤖</span> Dindicator Agent
        </div>
      </Divider>
      <ConversationLayout />
    </div>
  );
};

export default Agent;
